import { on } from 'events';
import React, { useEffect, useState, useRef } from 'react';
import { FaTimes } from 'react-icons/fa';

import axios from '../../api/axios';

interface AddressProps {
  isOpen: boolean;
  onClose: () => void;
  onSave: (
    alamat: string, 
    label: string,
    lat?: number | null | undefined,
    lng?: number | null | undefined
  ) => void; 
  data: {
    alamat?: string;
    label?: string;
    lat?: number | null;
    lng?: number | null;
  };
}

const Address: React.FC<AddressProps> = ({ isOpen, onClose, onSave, data }) => {
 
    const mapRef = useRef<HTMLDivElement>(null);
    const inputRef = useRef<HTMLInputElement>(null);
    const defaultLat = -6.200000;
    const defaultLng = 106.816666;

    const storedData = sessionStorage.getItem('userData');
    const userDataDefault = storedData ? JSON.parse(storedData) : {};

    const [userData, setUserData] = useState(userDataDefault);
    
    const [token, setToken] = useState<string>(userData?.token || '');


    const [map, setMap] = useState<google.maps.Map>();
    const [marker, setMarker] = useState<google.maps.Marker>();
    const [lat, setLat] = useState<number>(
      typeof data.lat === 'number' ? data.lat : defaultLat
    );
    const [lng, setLng] = useState<number>(
      typeof data.lng === 'number' ? data.lng : defaultLng
    );

    const [label, setLabel] = useState(data.label || 'Rumah');
    const [address, setAddress] = useState(data.alamat || '');
    
    
    useEffect(() => {
      if (isOpen && mapRef.current && inputRef.current) {
        const center = { lat: lat, lng: lng }; // Jakarta default
        const mapInstance = new google.maps.Map(mapRef.current, {
            center,
            zoom: 14,
            mapTypeControl: false,
        });
        const markerInstance = new google.maps.Marker({
            position: center,
            map: mapInstance,
            draggable: true,
        });

        const autocomplete = new google.maps.places.Autocomplete(inputRef.current as HTMLInputElement);
        autocomplete.bindTo("bounds", mapInstance);
        autocomplete.setFields(["name","geometry", "formatted_address"]);

        autocomplete.addListener("place_changed", () => {
            const place = autocomplete.getPlace();
            if (!place.geometry) return;

            const location = place.geometry?.location;

            const formatted_address = place.name + ' - ' + place.formatted_address

            if (location) {
                mapInstance.setCenter(location);
                mapInstance.setZoom(16);
                markerInstance.setPosition(location);

                // Dapatkan lat dan lng dari lokasi
                const lat = location.lat();
                const lng = location.lng();
                setLat(lat);
                setLng(lng);
                setAddress(formatted_address || '');

            }

        });

        // Update address when marker moved
        google.maps.event.addListener(markerInstance, 'dragend', function () {
            const latLng = markerInstance.getPosition();
            if (!latLng) return;

            // Simpan lat dan lng saat marker digeser
            const lat = latLng.lat();
            const lng = latLng.lng();
            setLat(lat);
            setLng(lng);

            const geocoder = new google.maps.Geocoder();
            geocoder.geocode({ location: latLng }, (results, status) => {
            if (status === 'OK' && results && results[0]) {
                setAddress(results[0].formatted_address);
                if (inputRef.current) inputRef.current.value = results[0].formatted_address;
            }
            });
        });

        setMap(mapInstance);
        setMarker(markerInstance);
        }
    }, [isOpen]);
    
    const handleOnsave = async () => {
        const fecthAddress = async () => {
          try {
            const response = await axios.post(`prescriptions/address`, {
              lat: lat,
              lng: lng,
              user_id: userData?.id,
              name: userData?.person?.name,
              phone: userData?.phone_code + userData?.phone,
              text: address
            }, {
              headers: {
                Authorization: `Bearer ${token}`,
              }
            });

            const data = response.data.data;
            console.log(data, "data");

          } catch (error) {
            console.error('Error fetching data:', error);
          }
        }
        fecthAddress();

        const fetchData = async () => {
          try {
            const response = await axios.post(`users`, null, {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            });

            const data = response.data.data;
            sessionStorage.setItem('userData', JSON.stringify(data));
            setUserData(data);
          } catch (error) {
            console.error('Error posting data:', error);
          }
        };

        fetchData();
        onSave(address, label, lat, lng);
    }
    
    if (!isOpen) return null;
    return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-xl p-4 w-full max-w-sm shadow-lg relative">
        <button className="absolute top-2 right-2 text-gray-600" onClick={onClose}>
          <FaTimes />
        </button>
        <div className="text-center sm:text-left">
          <div className="w-10 h-1 bg-gray-300 rounded-full mx-auto sm:hidden mb-2" />
          <h2 className="text-lg font-semibold text-teal-600">Pilih Alamat Pengiriman</h2>
        </div>
        <div className="mt-4">
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Pastikan lokasi pengiriman sudah tepat untuk memudahkan pengantaran obat.
          </label>

          <hr className='mt-2 mb-2'/>

          <label className="block text-sm font-medium text-gray-700 mb-2">Label Alamat</label>
          <div className="flex space-x-4 mb-4">
            <label className="flex items-center">
              <input
                type="radio"
                name="label"
                value="Rumah"
                checked={label === "Rumah"}
                onChange={(e) => setLabel(e.target.value)}
                className="mr-2"
              />
              Rumah
            </label>
            <label className="flex items-center">
              <input
                type="radio"
                name="label"
                value="Kantor"
                checked={label === "Kantor"}
                onChange={(e) => setLabel(e.target.value)}
                className="mr-2"
              />
              Kantor
            </label>
          </div>
        </div>
        <input
          ref={inputRef}
          className="border w-full p-2 rounded text-sm mb-3"
          placeholder="Cari alamat..."
          defaultValue={address}
        />
        <div ref={mapRef} className="w-full h-64 rounded mb-4" />
        <button className="w-full py-2 bg-teal-600 text-white font-semibold rounded hover:bg-teal-700"
        onClick={handleOnsave}
        >
          Simpan
        </button>
      </div>
    </div>
  );
};

export default Address;
